import dynamic from 'next/dynamic';
import Head from 'next/head';

import { HeaderHomePreLogin } from '@/shared/components/Header/HomePreLogin';
import { executeEvent } from '@/shared/events/Firebase/firebaseEvents';
import { useDisclosure } from '@/shared/hooks/useDisclosure';
import { ModalAddressFactoryProps } from '@main/factories/Address';
import { ModalAuthFactoryProps } from '@main/factories/Auth';

import { HeroHomePreLoginProps } from './Hero';
import { HeroMobileHomePreLoginProps } from './Hero/Mobile';
import * as S from './styles';

const HeroHomePreLogin = dynamic<HeroHomePreLoginProps>(() =>
  import('./Hero').then(module => module.HeroHomePreLogin),
);

const HeroMobileHomePreLogin = dynamic<HeroMobileHomePreLoginProps>(() =>
  import('./Hero/Mobile').then(module => module.HeroMobileHomePreLogin),
);

const LearnMoreHomePreLogin = dynamic<JSX.Element>(() =>
  import('./LearnMore').then(module => module.LearnMoreHomePreLogin),
);

const FooterHomePreLogin = dynamic<JSX.Element>(() =>
  import('./Footer').then(module => module.FooterHomePreLogin),
);

const ModalAuthFactory = dynamic<ModalAuthFactoryProps>(() =>
  import('@main/factories/Auth').then(module => module.ModalAuthFactory),
);

const ModalAddressFactory = dynamic<ModalAddressFactoryProps>(() =>
  import('@main/factories/Address').then(module => module.ModalAddressFactory),
);

export const PreviousLogin = () => {
  const authDisclosure = useDisclosure();
  const addressDisclosure = useDisclosure();

  const handleCloseAddressModal = () => {
    executeEvent('event_exit_addresses', {});
    addressDisclosure.onClose();
  };

  return (
    <>
      <Head>
        {/* TODO change title and meta description */}
        <title>Farmácias APP - Medicamentos e Muito Mais</title>
        <meta
          name="description"
          content="Cosméticos, Medicamentos, Suplementos e Muito Mais | Confira Nossas Ofertas Imperdíveis. Levamos o Produto que Você Precisa Até Você | Um Delivery de Farmácia em Suas Mãos."
        />
        <meta
          name="google-site-verification"
          content="HKW9un7eTqqCiBrnpTvJDj4hSyADzjQU-JgLkUZqiEs"
        />
      </Head>

      <S.WrapperPreLogin>
        <HeaderHomePreLogin onOpenModalAuth={authDisclosure.onOpen} />
        <S.Wrapper>
          <S.HeroMobile>
            <HeroMobileHomePreLogin addressDisclosure={addressDisclosure} />
          </S.HeroMobile>

          <S.HeroDesktop>
            <HeroHomePreLogin addressDisclosure={addressDisclosure} />
          </S.HeroDesktop>

          <LearnMoreHomePreLogin props={{}} type key="learnMore" />
          <FooterHomePreLogin props={{}} type key="footer" />
        </S.Wrapper>
      </S.WrapperPreLogin>

      <ModalAuthFactory
        isOpen={authDisclosure.isOpen}
        onClose={authDisclosure.onClose}
      />
      <ModalAddressFactory
        isOpen={addressDisclosure.isOpen}
        onOpen={addressDisclosure.onOpen}
        onClose={handleCloseAddressModal}
      />
    </>
  );
};
